import styled from 'styled-components';

export const Container = styled.div`
  height: 82px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.hotelDetails.bookingInfo};
  display: flex;
  width: 100%;
  font-size: 12px;
`;

export const BookingInfoHeader = styled.div`
  font-family: Poppins;
  font-size: 12px;
  color: ${({ theme }) => theme.hotelDetails.roomTitleColor};
  display: flex;
  width: 100%;
  padding: 22px 0 22px;
`;

export const BookingInfoDates = styled.div`
  border-right: 1px solid ${({ theme }) => theme.hotelDetails.bookingInfoDates};
  font-weight: 600;
  font-size: 12px;
  width: 50%;
  justify-content: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const RoomLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
`;

export const RoomGuest = styled.span`
  font-size: 12px;
  font-weight: normal;
`;

export const BookingInfoRooms = styled.div`
  font-weight: normal;
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 50%;
  font-size: 12px;
  text-align: left;
`;

export const Date = styled.span`
  text-align: left;
  font-size: 12px;
  font-weight: normal;
  width: 100%;
`;

export const EditIcon = styled.img`
  font-size: 20px;
  cursor: pointer;
`;

export const EditContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20%;
  border-left: 1px solid ${({ theme }) => theme.hotelDetails.background};
`;

export const DateContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const RoomContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;
